import React from 'react';
import Flex from '@applied/dragonfruit/src/components/Layout/Flex';
import { Typography } from '@applied/dragonfruit/src/components/Text/Typography';

import { VideoAndDescription } from 'components/common/VideoAndDescription/VideoAndDescription';

import './resources-section.scss';

export function ResourcesSection(): JSX.Element {
  return (
    <div id="resources">
      <Flex className="resources-section" direction="column" gap="lg" padding="xxl">
        <Flex className="section-header" direction="column">
          <Typography variant="title">RESOURCES</Typography>
          <Typography variant="header">Making the decision</Typography>
        </Flex>
        <div className="body">
          <VideoAndDescription
            src="https://player.vimeo.com/video/813915927?h=5090b07110&app_id=122963&dntp=1"
            title="Why Join Applied Intuition"
            header="Why join Applied Intuition"
            description="Choosing the right startup is hard. Consider the company’s values, culture, long-term vision; these all need to align to ensure you are making the right decision. Hear from our cofounder directly on why Applied Intuition could be a good fit for you."
          />
          <VideoAndDescription
            src="https://player.vimeo.com/video/814137520?h=9571cecf41&app_id=122963&dntp=1"
            title="Compensation Philosophy"
            header="Compensation Philosophy"
            description="Our CTO breaks down how we structure our compensation packages. We want to strike the right balance in making sure you are excited about the numbers while still focusing on why candidates decide to join us: the equity ownership."
          />
        </div>
      </Flex>
    </div>
  );
}
